module.exports = __webpack_public_path__ + "static/media/inktoberApples.e7b586ba.gif";